// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from './plugins/persistence'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
//   getters,
  plugins: [createPersistedState()],
  strict: process.env.NODE_ENV !== 'production'
})